var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{staticClass:"sigcanvas",attrs:{"id":_vm.sigid}}),_c('linkbutton',{attrs:{"toplabel":"clear"},on:{"click":_vm.clear}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }